// Home · Ask · Create in one row. A destination opens its last view; its
// chevron (or ArrowDown) opens the contextual modes. Human / Agent lives in
// the avatar menu, with the same switch retained in the Agent frame.
export const HomeViewSwitch = {
  class: 'home-view-switch',
  display: 'flex',
  justifyContent: 'center',
  minWidth: '0',
  flexShrink: '0',
  subscribeTo: [
    '_aiFly',
    '_aiDeck',
    'assistantMode',
    'currentPath',
    '_homeCustomizeMode',
    '_homeThreadOpen',
    'assistantDock',
    'workspace',
    '_featureFlags',
    'signedIn',
    'contextDropdown'
  ],
  hide: (el, s) => !el.call('homeViewShown', s.root),
  AppSegmented: {
    dataHomeNav: 'primary',
    variant: 'view',
    ariaLabel: (el) => el.call('polyglot', 'workspace.homeView.label'),
    current: (el, s) => el.call('homeViewGroupOf', s.root),
    select: 'homeViewGroupSelect',
    childrenAs: 'state',
    children: (el) => el.call('homeViewGroups'),
    childProps: {
      text: null,
      gap: 'Y',
      ariaHaspopup: (el, s) => (s.value === 'home' ? null : 'menu'),
      ariaExpanded: (el, s) =>
        s.value === 'home'
          ? null
          : String(
              !!s.root.contextDropdown?.open && s.root.contextDropdown?.homeViewGroup === s.value
            ),
      onClick: (e, el, s) => {
        const menu =
          s.value !== 'home' &&
          (el.call('homeViewGroupOf', s.root) === s.value ||
            e.target?.closest?.('[data-home-mode-trigger]'))
        return menu
          ? el.call('homeViewMenuOpen', el, s.value)
          : el.call('homeViewGroupSelect', s.value)
      },
      onKeydown: (e, el) => el.call('homeViewNavigationKeydown', e, el),
      onPointerenter: (e, el, s) =>
        el.call('homeBuildPrefetch', s.value === 'create' ? 'build' : null),
      onFocus: (e, el, s) => el.call('homeBuildPrefetch', s.value === 'create' ? 'build' : null),
      Text: { text: (el, s) => el.call('polyglot', s.text) },
      Icon: {
        name: 'chevronDown',
        size: 'Z',
        dataHomeModeTrigger: true,
        ariaHidden: 'true',
        hide: (el, s) => s.value === 'home'
      }
    }
  }
}
